import { useMutation, UseMutationResult, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { BikeleasingSettingsPatchRequestDTO, BikeleasingSettingsResponseDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';
import { useWithMessage } from 'probonio-shared-ui/module/error';
import { useTenantID } from 'probonio-shared-ui/module/me';

const SETTINGS_QUERY_SUFFIX = ['benefits', 'bikeleasing_v2', 'settings'];

export function useBikeleasingSettings(): UseQueryResult<BikeleasingSettingsResponseDTO> {
  return useTenantQuery(SETTINGS_QUERY_SUFFIX, async tenantId => {
    const res = await apis.bikeLeasingV2.getBikeleasingSettings({ tenantId });
    return res.data;
  });
}

export function useUpdateBikeleasingSettings(): UseMutationResult<string, Error, BikeleasingSettingsPatchRequestDTO> {
  const getTenantId = useTenantID();
  const queryClient = useQueryClient();
  const withMessage = useWithMessage();

  return useMutation({
    mutationFn: async bikeleasingSettingsPatchRequestDTO => {
      const tenantId = getTenantId();
      await apis.bikeLeasingV2.updateBikeleasingSettings({
        tenantId,
        bikeleasingSettingsPatchRequestDTO,
      });
      return tenantId;
    },
    onSuccess: async tenantId => {
      await queryClient.invalidateQueries({ queryKey: ['tenants', tenantId, ...SETTINGS_QUERY_SUFFIX] });
    },
    onError: error => {
      withMessage(error);
    },
  });
}
